import React from "react"
import { Link } from "gatsby"
import Blog from "./Blog"
import styled from "styled-components"

const StyledProjectsSection = styled.section`
  @media (max-width: 768px) {
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover,
    &:focus {
      box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.7);
    }
  }
  ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 15px;
    padding: 0;
    margin: 0;
  }
`
const StyledLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .email-link {
    margin-top: 48px;
    color: #d1f7ff;
    background-color: transparent;
    border: 1px solid #d1f7ff;
    border-radius: 4px;
    padding: 1.25rem 1.75rem;
    font-size: 16px;
    font-family: poppins;
    line-height: 1;
    text-decoration: none !important;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    &:hover,
    &:focus,
    &:active {
      background-color: rgba(100, 255, 218, 0.1);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  }
`

export default function Blogs({ blogs, title, showLink }) {
  return (
    <section id="blog">
      <StyledProjectsSection>
        <h2 className="numbered-heading">{title}</h2>
        <ul className="">
          {blogs.map(blog => {
            return <Blog key={blog.id} {...blog} />
          })}
        </ul>
      </StyledProjectsSection>
      <StyledLink>
        {showLink && (
          <Link className=" email-link" to="/blog">
            view blog-page
          </Link>
        )}
      </StyledLink>
    </section>
  )
}
